<template>
  <div>
      <!-- other_form_fees_data:{{ other_form_fees_data }} <br /><br /> -->

      <!-- shiv receipt code -->
      <v-card flat>
          <v-toolbar class="toolbar no-display" flat dense>
              <v-toolbar-title>
                  <strong> Print Receipt </strong>
              </v-toolbar-title>
              <v-spacer></v-spacer>
          </v-toolbar>
          <v-btn v-if="other_form_fees_data != null" class="ma-2 no-display" tile outlined color="warning" @click="print()"> <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon> </v-btn>
          <v-radio-group v-model="radios" mandatory row class="ma-2 no-display">
              <v-radio label="Both" value="both" color="#0f2027"></v-radio>
              <v-radio label="Office Copy" value="office" color="#0f2027"></v-radio>
              <v-radio label="Student Copy" value="student" color="#0f2027"></v-radio>
          </v-radio-group>
          <v-row justify="center" dense class="ma-2 no-display">
                <v-col cols="12" sm="6" md="6" >
                    <v-text-field outlined rounded dense hint="Enter Receipt Header" persistent-hint label="Receipt Header" type="text" v-model="receipt_header"></v-text-field>
                </v-col>
            </v-row>
          <v-row v-if="other_form_fees_data != null && radios != 'both'">
              <v-col cols="12" sm="6" md="6" class="m-0 p-0" v-if="radios == 'office'">
                  <v-card>
                      <v-simple-table dense class="elevation-1 table-container">
                          <template v-slot:default>
                              <thead>
                                  <tr>
                                      <td colspan="3">
                                          <center>
                                              <strong class="fee-str" style="line-height: 2.5em;">{{receipt_header}}</strong>
                                          </center>
                                      </td>
                                  </tr>
                                  <tr>
                                      <th v-if="org_basic_data.trust_logo">
                                          <center>
                                              <img :src="org_basic_data.trust_logo" width="45%" alt="logo" />
                                          </center>
                                      </th>
                                      <td>
                                          <center>
                                              <tr v-if="org_basic_data.trust_name">
                                                  <strong>{{ org_basic_data.trust_name }}</strong>
                                              </tr>
                                              <tr v-if="org_basic_data.school_name">
                                                  <strong>{{ org_basic_data.school_name }} </strong>
                                              </tr>
                                              <tr v-if="org_basic_data.address">
                                                  {{ org_basic_data.address }}
                                              </tr>
                                              <tr v-if="org_basic_data.phone">
                                                  Phone : {{ org_basic_data.phone }}
                                              </tr>
                                              <tr v-if="org_basic_data.email">
                                                  Email : {{ org_basic_data.email }}
                                              </tr>
                                              <tr v-if="org_basic_data.website">
                                                  Website : {{ org_basic_data.website }}
                                              </tr>
                                          </center>
                                      </td>
                                      <th v-if="org_basic_data.school_logo">
                                          <center>
                                              <img :src="org_basic_data.school_logo" width="60%" alt="logo" />
                                          </center>
                                      </th>
                                  </tr>

                                  <tr>
                                      <td colspan="1">
                                          Form No. : {{ other_form_fees_data.form_no }}
                                      </td>
                                      <td colspan="1">
                                          Name : {{ other_form_fees_data.name }}
                                      </td>
                                      <td colspan="1">D.O.B.: {{ other_form_fees_data.dob }}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="1">
                                          Academic Year : {{ other_form_fees_data.academicyear }}
                                      </td>
                                      <td colspan="1">
                                          <span v-if="other_form_fees_data.standard">Standard : {{ other_form_fees_data.standard }}</span>
                                      </td>
                                      <td colspan="1">
                                          Date : {{ other_form_fees_data.generation_date }}
                                      </td>
                                  </tr>
                                  <tr>
                                      <td colspan="2"><strong>Paticulars of Fee</strong></td>
                                      <td><strong> Fee Amount (Rs.)</strong></td>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr>
                                      <td colspan="2">
                                          {{ other_form_fees_data.remark }}
                                      </td>
                                      <td>{{ other_form_fees_data.amount }}</td>
                                  </tr>
                              </tbody>
                              <!-- <tr>
                                  <td colspan="3"><strong> Fine ::</strong> Rs. {{learner_receipt_data.fine}}</td>
                                  
                              </tr> -->
                              <!-- <tr>
                                  <td colspan="3" class="text-left"><strong> Total Payable Amount ::</strong> Rs. {{learner_receipt_data.total_fees_amount}}.00 ( {{ convert(learner_receipt_data.total_fees_amount) }} Only)</td>
                              </tr> -->
                              <tr>
                                  <td colspan="3" class="text-left">
                                      <strong> Payment Mode :: </strong>
                                      {{ other_form_fees_data.mode }}
                                  </td>
                              </tr>

                              <tr>
                                  <td colspan="3" class="text-right">
                                      <v-col cols="12" md="12" sm="12">
                                          <strong>Authorized Signature</strong>
                                      </v-col>
                                  </td>
                              </tr>
                          </template>
                      </v-simple-table>
                  </v-card>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="m-0 p-0" v-if="radios == 'student'">
                  <v-card>
                      <v-simple-table dense class="elevation-1 table-container">
                          <template v-slot:default>
                              <thead>
                                  <tr>
                                      <td colspan="3">
                                          <center>
                                              <strong class="fee-str">{{receipt_header}}</strong>
                                          </center>
                                      </td>
                                  </tr>
                                  <tr>
                                      <th v-if="org_basic_data.trust_logo">
                                          <center>
                                              <img :src="org_basic_data.trust_logo" width="45%" alt="logo" />
                                          </center>
                                      </th>
                                      <td>
                                          <center>
                                              <tr v-if="org_basic_data.trust_name">
                                                  <strong>{{ org_basic_data.trust_name }}</strong>
                                              </tr>
                                              <tr v-if="org_basic_data.school_name">
                                                  <strong>{{ org_basic_data.school_name }} </strong>
                                              </tr>
                                              <tr v-if="org_basic_data.address">
                                                  {{ org_basic_data.address }}
                                              </tr>
                                              <tr v-if="org_basic_data.phone">
                                                  Phone : {{ org_basic_data.phone }}
                                              </tr>
                                              <tr v-if="org_basic_data.email">
                                                  Email : {{ org_basic_data.email }}
                                              </tr>
                                              <tr v-if="org_basic_data.website">
                                                  Website : {{ org_basic_data.website }}
                                              </tr>
                                          </center>
                                      </td>
                                      <th v-if="org_basic_data.school_logo">
                                          <center>
                                              <img :src="org_basic_data.school_logo" width="60%" alt="logo" />
                                          </center>
                                      </th>
                                  </tr>

                                  <tr>
                                      <td colspan="1">
                                          Form No. : {{ other_form_fees_data.form_no }}
                                      </td>
                                      <td colspan="1">
                                          Name : {{ other_form_fees_data.name }}
                                      </td>
                                      <td colspan="1">D.O.B.: {{ other_form_fees_data.dob }}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="1">
                                          Academic Year : {{ other_form_fees_data.academicyear }}
                                      </td>
                                      <td colspan="1">
                                          <span v-if="other_form_fees_data.standard">Standard : {{ other_form_fees_data.standard }}</span>
                                      </td>
                                      <td colspan="1">
                                          Date : {{ other_form_fees_data.generation_date }}
                                      </td>
                                  </tr>
                                  <tr>
                                      <td colspan="2"><strong>Paticulars of Fee</strong></td>
                                      <td><strong> Fee Amount (Rs.)</strong></td>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr>
                                      <td colspan="2">
                                          {{ other_form_fees_data.remark }}
                                      </td>
                                      <td>{{ other_form_fees_data.amount }}</td>
                                  </tr>
                              </tbody>
                              <!-- <tr>
                                  <td colspan="3"><strong> Fine ::</strong> Rs. {{learner_receipt_data.fine}}</td>
                                  
                              </tr> -->
                              <!-- <tr>
                                  <td colspan="3" class="text-left"><strong> Total Payable Amount ::</strong> Rs. {{learner_receipt_data.total_fees_amount}}.00 ( {{ convert(learner_receipt_data.total_fees_amount) }} Only)</td>
                              </tr> -->
                              <tr>
                                  <td colspan="3" class="text-left">
                                      <strong> Payment Mode :: </strong>
                                      {{ other_form_fees_data.mode }}
                                  </td>
                              </tr>
                              <!-- <tr>
                                  <td colspan="3" class="text-left"><strong> Payment Details:</strong> {{ learner_receipt_data.remark }}</td>
                              </tr> -->
                              <!-- <tr>
                                  <td colspan="3" class="text-right">
                                  <v-col cols="12" md="12" sm="12">
                                      
                                      </v-col>
                                  </td>
                              </tr> -->
                              <tr>
                                  <td colspan="3" class="text-right">
                                      <v-col cols="12" md="12" sm="12">
                                          <strong>Authorized Signature</strong>
                                      </v-col>
                                  </td>
                              </tr>
                          </template>
                      </v-simple-table>
                  </v-card>
              </v-col>
          </v-row>
          <v-row v-if="other_form_fees_data != null && radios == 'both'">
              <v-col cols="12" sm="6" md="6" class="m-0 p-0">
                  <v-card>
                      <v-simple-table dense class="elevation-1 table-container">
                          <template v-slot:default>
                              <thead>
                                  <tr>
                                      <td colspan="3">
                                          <center>
                                              <strong class="fee-str">{{receipt_header}}</strong>
                                          </center>
                                      </td>
                                  </tr>
                                  <tr>
                                      <th v-if="org_basic_data.trust_logo">
                                          <center>
                                              <img :src="org_basic_data.trust_logo" width="45%" alt="logo" />
                                          </center>
                                      </th>
                                      <td>
                                          <center>
                                              <tr v-if="org_basic_data.trust_name">
                                                  <strong>{{ org_basic_data.trust_name }}</strong>
                                              </tr>
                                              <tr v-if="org_basic_data.school_name">
                                                  <strong>{{ org_basic_data.school_name }} </strong>
                                              </tr>
                                              <tr v-if="org_basic_data.address">
                                                  {{ org_basic_data.address }}
                                              </tr>
                                              <tr v-if="org_basic_data.phone">
                                                  Phone : {{ org_basic_data.phone }}
                                              </tr>
                                              <tr v-if="org_basic_data.email">
                                                  Email : {{ org_basic_data.email }}
                                              </tr>
                                              <tr v-if="org_basic_data.website">
                                                  Website : {{ org_basic_data.website }}
                                              </tr>
                                          </center>
                                      </td>
                                      <th v-if="org_basic_data.school_logo">
                                          <center>
                                              <img :src="org_basic_data.school_logo" width="60%" alt="logo" />
                                          </center>
                                      </th>
                                  </tr>

                                  <tr>
                                      <td colspan="1">
                                          Form No. : {{ other_form_fees_data.form_no }}
                                      </td>
                                      <td colspan="1">
                                          Name : {{ other_form_fees_data.name }}
                                      </td>
                                      <td colspan="1">D.O.B.: {{ other_form_fees_data.dob }}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="1">
                                          Academic Year : {{ other_form_fees_data.academicyear }}
                                      </td>
                                      <td colspan="1">
                                          <span v-if="other_form_fees_data.standard">Standard : {{ other_form_fees_data.standard }}</span>
                                      </td>
                                      <td colspan="1">
                                          Date : {{ other_form_fees_data.generation_date }}
                                      </td>
                                  </tr>
                                  <tr>
                                      <td colspan="2"><strong>Paticulars of Fee</strong></td>
                                      <td><strong> Fee Amount (Rs.)</strong></td>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr>
                                      <td colspan="2">
                                          {{ other_form_fees_data.remark }}
                                      </td>
                                      <td>{{ other_form_fees_data.amount }}</td>
                                  </tr>
                              </tbody>
                              <!-- <tr>
                                  <td colspan="3"><strong> Fine ::</strong> Rs. {{learner_receipt_data.fine}}</td>
                                  
                              </tr> -->
                              <!-- <tr>
                                  <td colspan="3" class="text-left"><strong> Total Payable Amount ::</strong> Rs. {{learner_receipt_data.total_fees_amount}}.00 ( {{ convert(learner_receipt_data.total_fees_amount) }} Only)</td>
                              </tr> -->
                              <tr>
                                  <td colspan="3" class="text-left">
                                      <strong> Payment Mode :: </strong>
                                      {{ other_form_fees_data.mode }}
                                  </td>
                              </tr>
                              <!-- <tr>
                                  <td colspan="3" class="text-left"><strong> Payment Details:</strong> {{ learner_receipt_data.remark }}</td>
                              </tr> -->
                              <!-- <tr>
                                  <td colspan="3" class="text-right">
                                  <v-col cols="12" md="12" sm="12">
                                      
                                      </v-col>
                                  </td>
                              </tr> -->
                              <tr>
                                  <td colspan="3" class="text-right">
                                      <v-col cols="12" md="12" sm="12">
                                          <strong>Authorized Signature</strong>
                                      </v-col>
                                  </td>
                              </tr>
                          </template>
                      </v-simple-table>
                  </v-card>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="m-0 p-0">
                  <v-card>
                      <v-simple-table dense class="elevation-1 table-container">
                          <template v-slot:default>
                              <thead>
                                  <tr>
                                      <td colspan="3">
                                          <center>
                                              <strong class="fee-str">{{receipt_header}}</strong>
                                          </center>
                                      </td>
                                  </tr>
                                  <tr>
                                      <th v-if="org_basic_data.trust_logo">
                                          <center>
                                              <img :src="org_basic_data.trust_logo" width="45%" alt="logo" />
                                          </center>
                                      </th>
                                      <td>
                                          <center>
                                              <tr v-if="org_basic_data.trust_name">
                                                  <strong>{{ org_basic_data.trust_name }}</strong>
                                              </tr>
                                              <tr v-if="org_basic_data.school_name">
                                                  <strong>{{ org_basic_data.school_name }} </strong>
                                              </tr>
                                              <tr v-if="org_basic_data.address">
                                                  {{ org_basic_data.address }}
                                              </tr>
                                              <tr v-if="org_basic_data.phone">
                                                  Phone : {{ org_basic_data.phone }}
                                              </tr>
                                              <tr v-if="org_basic_data.email">
                                                  Email : {{ org_basic_data.email }}
                                              </tr>
                                              <tr v-if="org_basic_data.website">
                                                  Website : {{ org_basic_data.website }}
                                              </tr>
                                          </center>
                                      </td>
                                      <th v-if="org_basic_data.school_logo">
                                          <center>
                                              <img :src="org_basic_data.school_logo" width="60%" alt="logo" />
                                          </center>
                                      </th>
                                  </tr>

                                  <tr>
                                      <td colspan="1">
                                          Form No. : {{ other_form_fees_data.form_no }}
                                      </td>
                                      <td colspan="1">
                                          Name : {{ other_form_fees_data.name }}
                                      </td>
                                      <td colspan="1">D.O.B.: {{ other_form_fees_data.dob }}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="1">
                                          Academic Year : {{ other_form_fees_data.academicyear }}
                                      </td>
                                      <td colspan="1">
                                          <span v-if="other_form_fees_data.standard">Standard : {{ other_form_fees_data.standard }}</span>
                                      </td>
                                      <td colspan="1">
                                          Date : {{ other_form_fees_data.generation_date }}
                                      </td>
                                  </tr>
                                  <tr>
                                      <td colspan="2"><strong>Paticulars of Fee</strong></td>
                                      <td><strong> Fee Amount (Rs.)</strong></td>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr>
                                      <td colspan="2">
                                          {{ other_form_fees_data.remark }}
                                      </td>
                                      <td>{{ other_form_fees_data.amount }}</td>
                                  </tr>
                              </tbody>
                              <!-- <tr>
                                  <td colspan="3"><strong> Fine ::</strong> Rs. {{learner_receipt_data.fine}}</td>
                                  
                              </tr> -->
                              <!-- <tr>
                                  <td colspan="3" class="text-left"><strong> Total Payable Amount ::</strong> Rs. {{learner_receipt_data.total_fees_amount}}.00 ( {{ convert(learner_receipt_data.total_fees_amount) }} Only)</td>
                              </tr> -->
                              <tr>
                                  <td colspan="3" class="text-left">
                                      <strong> Payment Mode :: </strong>
                                      {{ other_form_fees_data.mode }}
                                  </td>
                              </tr>
                              <!-- <tr>
                                  <td colspan="3" class="text-left"><strong> Payment Details:</strong> {{ learner_receipt_data.remark }}</td>
                              </tr> -->
                              <!-- <tr>
                                  <td colspan="3" class="text-right">
                                  <v-col cols="12" md="12" sm="12">
                                      
                                      </v-col>
                                  </td>
                              </tr> -->
                              <tr>
                                  <td colspan="3" class="text-right">
                                      <v-col cols="12" md="12" sm="12">
                                          <strong>Authorized Signature</strong>
                                      </v-col>
                                  </td>
                              </tr>
                          </template>
                      </v-simple-table>
                  </v-card>
              </v-col>
          </v-row>
          <!-- <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay> -->
      </v-card>
      <!-- shiv code end -->
  </div>
</template>

<script>
  export default {
    //   props: ["other_form_fees_data", "org_basic_data"],
      data() {
          return {
              radios: null,
              receipt_header:"Form fee Receipt",
              other_form_fees_data: null,
              receipt_dialog: false,
              org_basic_data: null,
          };
      },
      created() {
          this.awspath = localStorage.getItem("awspath");
      },
      mounted() {
          this.receipt_dialog = JSON.parse(localStorage.getItem("receipt_dialog"));
          this.other_form_fees_data = JSON.parse(localStorage.getItem("other_form_fees_data"));
          this.org_basic_data = JSON.parse(localStorage.getItem("org_basic_data"));
      },
      methods: {
          print() {
              setTimeout(function () {
                  window.print();
              }, 100);
          },
      },
  };
</script>

<style scoped>
  @media all and (max-width: 900px) {
      .padding-bot {
          padding: 8px;
      }
  }

  tr,
  td,
  th {
      border: 1px solid #ccc;
      text-align: center;
      /* font-size: small; */
      font-size: 15px;
      line-height: 1.9em;
  }
  tr,
  tbody {
      border-bottom: 1px solid #ccc;
      border: 1px solid #ccc;
  }

  @media (min-width: 320px) {
      td,
      th {
          display: table-cell !important;
          /* font-size: small; */
          font-size: 15px;
          line-height: 2.5em;
      }
      td + td,
      th + th {
          width: auto;
          /* font-size: small; */
          font-size: 15px;
          line-height: 2.5em;
      }
  }
  v-simple-table {
      white-space: nowrap !important;
      text-align: center;
  }
  @media print {
      header,
      footer,
      nav,
      date {
          display: none !important;
      }
      
      .fee-str {
          font-size: 36px !important;
      }
      table,
      td,
      tr {
          break-inside: avoid-page;
      }
      /* img {
  width: 100% !important;
} */
      
      body,
      tr,
      th,
      td {
          font-size: xx-large !important;
          /* font-weight: bold !important; */
      }
      .no-display,
      .v-input__control,
      input[type="button"],
      input[type="submit"],
      input[type="reset"],
      #v-card {
          display: none !important;
      }
      @page {
          size: A4 landscape;
          margin-top: none;
          padding-top: none;
          size: 25in 15in;
      }
      
      table,
      td,
      tr,
      th {
          text-align: center !important;
          margin-top: none;
          padding: 1.4rem 0.6rem !important; 
          line-height: 2.7em !important;
          font-size: xx-large !important;
          /* font-weight: bold !important; */
          border-bottom: 1px solid black;
          border: 1px solid black;
      }
  }

  .table-container {
      overflow-x: hidden;
      overflow: hidden;
  }
  .text {
      color: red !important;
      font-size: bold !important;
  }
</style>

<style>
@media print {
    @page {
        size: A4 landscape !important;
        margin: 5mm !important; 
    }
    html, body, .v-application {
        height: 100% !important;
        max-height: 100% !important;
        overflow: hidden !important; 
        margin: 0 !important;
        padding: 0 !important;
        box-sizing: border-box !important;
    }
    .v-application--wrap {
        zoom: 0.64 !important;
        transform-origin: top center !important;
        height: auto !important;
        min-height: unset !important;
        width: 100% !important;
        box-sizing: border-box !important;
    }
    .v-col, .v-card, table {
        box-sizing: border-box !important;
    }
}
</style>